import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const tableWrapper = this.element;
    const tableContainer = tableWrapper.querySelector("#tableContainer");
    const tableHeader = tableWrapper.querySelector("#tableHeader");
    const mainTableContent = tableWrapper.querySelector("#mainTableContent");

    // Hide content initially if we have a saved scroll position (mobile only)
    const savedScrollLeft = sessionStorage.getItem("teamStatsScrollLeft");
    const isMobile = window.innerWidth < 768; // md breakpoint
    if (savedScrollLeft !== null && isMobile) {
      console.log(
        "stattable: hiding content initially for smooth scroll restoration (mobile)",
      );
      // Hide only the non-sticky rows with opacity for smooth fade
      const nonStickyRows = mainTableContent.querySelectorAll(
        'tr:not([data-row-type="mobileSticky"])',
      );
      nonStickyRows.forEach((row) => {
        row.style.transition = "opacity 0.2s ease-in-out";
        row.style.opacity = "0";
      });

      // Also hide table header cells with opacity
      const headerCells = tableHeader.querySelectorAll("th");
      headerCells.forEach((cell) => {
        cell.style.transition = "opacity 0.2s ease-in-out";
        cell.style.opacity = "0";
      });
    }

    this.bindHeaderWidths();
    this.bindScrolling(tableContainer, tableHeader);
    this.restoreScrollPosition();

    // Observe changes in the mainTableContent
    const observer = new MutationObserver(() => this.bindHeaderWidths());
    observer.observe(mainTableContent, { subtree: true, childList: true });

    // Bind widths on window resize
    window.addEventListener("resize", () => this.bindHeaderWidths());

    // Save scroll position before turbo navigation
    this.saveScrollPositionOnNavigation();
  }

  saveScrollPositionOnNavigation() {
    const tableContainer = this.element.querySelector("#tableContainer");
    if (!tableContainer) {
      console.log("stattable: tableContainer not found for saving scroll");
      return;
    }

    // Listen for clicks on sort links
    const sortLinks = this.element.querySelectorAll('a[href*="sort="]');
    console.log("stattable: found", sortLinks.length, "sort links");
    sortLinks.forEach((link) => {
      link.addEventListener("click", () => {
        const scrollLeft = tableContainer.scrollLeft;
        console.log(
          "stattable: saving scroll position on sort click:",
          scrollLeft,
        );
        sessionStorage.setItem("teamStatsScrollLeft", scrollLeft);
      });
    });

    // Listen for clicks on filter dropdown links
    const filterLinks = this.element.querySelectorAll('a[href*="stats="]');
    console.log("stattable: found", filterLinks.length, "filter links");
    filterLinks.forEach((link) => {
      link.addEventListener("click", () => {
        const scrollLeft = tableContainer.scrollLeft;
        console.log(
          "stattable: saving scroll position on filter click:",
          scrollLeft,
        );
        sessionStorage.setItem("teamStatsScrollLeft", scrollLeft);
      });
    });
  }

  restoreScrollPosition() {
    const tableContainer = this.element.querySelector("#tableContainer");
    if (!tableContainer) {
      console.log("stattable: tableContainer not found for restoring scroll");
      return;
    }

    const savedScrollLeft = sessionStorage.getItem("teamStatsScrollLeft");
    const isMobile = window.innerWidth < 768; // md breakpoint
    console.log(
      "stattable: attempting to restore scroll position:",
      savedScrollLeft,
      "isMobile:",
      isMobile,
    );

    if (savedScrollLeft !== null) {
      // Use requestAnimationFrame to ensure DOM is fully rendered
      requestAnimationFrame(() => {
        const scrollValue = parseInt(savedScrollLeft, 10);
        console.log("stattable: setting scrollLeft to:", scrollValue);
        tableContainer.scrollLeft = scrollValue;
        console.log(
          "stattable: actual scrollLeft after setting:",
          tableContainer.scrollLeft,
        );

        // Show the content after scroll position is set (mobile only)
        if (isMobile) {
          console.log(
            "stattable: showing content after scroll restoration (mobile)",
          );

          // Add a small delay to ensure header width calculations are complete
          setTimeout(() => {
            const mainTableContent =
              this.element.querySelector("#mainTableContent");
            const tableHeader = this.element.querySelector("#tableHeader");

            // Fade in non-sticky rows
            const nonStickyRows = mainTableContent.querySelectorAll(
              'tr:not([data-row-type="mobileSticky"])',
            );
            nonStickyRows.forEach((row) => {
              row.style.opacity = "1";
            });

            // Fade in header cells
            const headerCells = tableHeader.querySelectorAll("th");
            headerCells.forEach((cell) => {
              cell.style.opacity = "1";
            });

            console.log("stattable: content visible after delay");
          }, 2); // 10ms delay
        }

        // Clear the saved position after restoring
        sessionStorage.removeItem("teamStatsScrollLeft");
      });
    } else {
      // If no saved position, make sure all content is visible
      const mainTableContent = this.element.querySelector("#mainTableContent");
      const tableHeader = this.element.querySelector("#tableHeader");

      const allRows = mainTableContent.querySelectorAll("tr");
      allRows.forEach((row) => {
        row.style.opacity = "1";
      });

      const headerCells = tableHeader.querySelectorAll("th");
      headerCells.forEach((cell) => {
        cell.style.opacity = "1";
      });
    }
  }

  bindHeaderWidths() {
    const mainTableContent = this.element.querySelector("#mainTableContent");
    const tableHeader = this.element.querySelector("#tableHeader");

    const tbody = mainTableContent.querySelector("tbody");
    if (!tbody) return;

    const rows = tbody.querySelectorAll("tr");
    if (rows.length === 0) return;

    // Use the last row for width calculations
    const lastRow = rows[rows.length - 1];
    const contentCells = lastRow.querySelectorAll("td");
    const headerCells = tableHeader.querySelectorAll("th:not(.hidden)"); // Skip hidden headers

    if (contentCells && headerCells) {
      // Start from index 1 (skip team column) and map to header cells starting from index 0
      for (let i = 1; i < contentCells.length; i++) {
        const headerIndex = i - 1;
        if (headerCells[headerIndex]) {
          const width = contentCells[i].offsetWidth;
          headerCells[headerIndex].style.width = `${width}px`;
          headerCells[headerIndex].style.minWidth = `${width}px`;
        }
      }
    }
  }

  bindScrolling(tableContainer, tableHeader) {
    tableContainer.addEventListener("scroll", () => {
      const scrollLeft = tableContainer.scrollLeft;
      tableHeader.style.transform = `translateX(${-scrollLeft}px)`;
    });
  }
}
